import { Link } from "react-router-dom";
import S from "./Logo.module.scss";
export const Logo = () => {
  return (
    <Link to="/" style={{ cursor: "pointer" }}>
      <svg
        className={S.logo}
        viewBox="0 0 1650 233"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1271.09 100.043C1264.78 100.039 1258.64 102.138 1253.64 106.011C1248.65 109.884 1245.07 115.313 1243.46 121.448L1238.66 139.723L1224.72 192.8V193.673C1223.5 198.295 1223.36 203.138 1224.29 207.827C1225.23 212.516 1227.23 216.926 1230.13 220.716C1233.03 224.506 1236.76 227.575 1241.03 229.686C1245.3 231.797 1249.99 232.893 1254.75 232.89H1307.59C1313.91 232.888 1320.05 230.788 1325.05 226.917C1330.06 223.046 1333.65 217.621 1335.27 211.485L1339.86 193.827L1354.06 139.723V139.261C1355.26 134.635 1355.39 129.795 1354.44 125.111C1353.49 120.427 1351.49 116.023 1348.59 112.237C1345.68 108.451 1341.96 105.384 1337.69 103.27C1333.43 101.157 1328.74 100.053 1323.98 100.043H1271.09ZM1306.06 205.89H1264.35C1262.88 205.892 1261.44 205.555 1260.12 204.907C1258.81 204.258 1257.66 203.314 1256.77 202.148C1255.87 200.982 1255.26 199.625 1254.97 198.182C1254.68 196.739 1254.73 195.249 1255.1 193.827V193.827L1269.3 139.723L1272.36 128.019H1314.33C1315.75 128.02 1317.16 128.348 1318.43 128.977C1319.7 129.607 1320.82 130.523 1321.69 131.653C1322.55 132.783 1323.15 134.098 1323.44 135.497C1323.72 136.896 1323.68 138.341 1323.32 139.723V139.723L1309.18 193.827L1306.06 205.89Z"
          fill="#FFD717"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1452.35 194.238H1453.01C1460 194.296 1466.8 192.011 1472.35 187.743C1477.9 183.476 1481.88 177.47 1483.65 170.676L1487.73 155.277L1491.46 139.877V139.415C1492.68 134.792 1492.83 129.95 1491.89 125.261C1490.96 120.572 1488.96 116.162 1486.06 112.372C1483.16 108.582 1479.43 105.513 1475.16 103.402C1470.89 101.291 1466.19 100.194 1461.44 100.197H1387.15L1352.42 232.993H1385.82L1413.34 128.122H1451.74C1453.16 128.123 1454.56 128.451 1455.83 129.08C1457.11 129.71 1458.22 130.626 1459.09 131.756C1459.96 132.886 1460.55 134.201 1460.84 135.6C1461.12 136.999 1461.08 138.444 1460.72 139.826V139.826L1458.22 150.862L1455.16 162.514C1454.85 163.951 1454.06 165.239 1452.93 166.171C1451.8 167.103 1450.39 167.623 1448.93 167.648H1413.19L1409.25 183.561L1444.43 232.839H1479.31L1452.35 194.238Z"
          fill="#FFD717"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M988.979 160.929C985.07 158.335 982.013 154.634 980.196 150.294C978.378 145.955 977.881 141.171 978.767 136.547L981.575 121.455C983.188 115.315 986.778 109.885 991.785 106.012C996.791 102.14 1002.93 100.043 1009.25 100.05H1062.05C1066.69 99.8279 1071.33 100.695 1075.58 102.582C1079.84 104.469 1083.6 107.325 1086.57 110.923C1089.54 114.522 1091.64 118.766 1092.7 123.32C1093.76 127.873 1093.75 132.612 1092.68 137.163H1061.53C1061.53 132.029 1060.26 128.026 1052.24 128.026H1016.09C1014.4 128.015 1012.76 128.569 1011.42 129.601C1010.08 130.632 1009.12 132.082 1008.69 133.723L1007.77 137.163L1070.32 174.224C1078.9 179.717 1079.61 190.137 1077.21 199.89L1074.45 211.337C1072.86 217.51 1069.27 222.976 1064.25 226.878C1059.24 230.78 1053.07 232.897 1046.73 232.897H992.144C967.278 232.897 959.007 212.723 961.1 194.552H992.349C992.349 199.018 992.042 205.896 1001.95 205.896H1039.83C1041.46 205.897 1043.04 205.36 1044.33 204.367C1045.63 203.374 1046.56 201.981 1046.98 200.404L1047.6 198.094L988.979 160.929Z"
          fill="#FFD717"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1157.12 232.897L1181.42 126.845L1223.09 126.947L1230.39 99.998H1112.95L1107.03 126.947H1148.44L1123.98 232.897H1157.12Z"
          fill="#FFD717"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1642.6 127.615L1650 99.998H1531.49L1525.11 127.615H1642.6Z"
          fill="#FFD717"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1605.68 151.172L1598.28 178.789H1548.09L1540.63 205.276H1627.18L1619.77 232.893H1497.54L1519.7 151.172H1605.68Z"
          fill="#FFD717"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M156.192 141.423H230.025L247.538 77.207H38.2949L35.7419 79.1063L0.612719 224.633L0 233H205.414L221.191 174.841H147.41L143.223 189.881L84.6573 190.189L102.835 122.533L167.272 122.225L160.532 125.408L156.192 141.423Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M216.189 233L215.27 228.945L329.235 77.207H409.604L459.336 228.945L457.753 233H402.047H386.524L356.348 145.581L357.573 132.389L314.479 185.98L317.849 191.318H369.164L371.615 197.683L342.511 233H216.189Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M694.773 232.894H608.175L564.162 173.4L628.65 124.788H553.797L563.906 130.486L541.542 232.894H465.82L501.103 77.1008L374.525 3.13126L372.942 0H568.604L664.188 48.2008L651.832 59.3912L771.669 0H969.986L967.126 3.13126L787.549 102.51L1027.63 228.89L1026.71 232.894H783.566L676.391 170.884L692.986 143.576L647.9 173.502L694.773 232.894Z"
          fill="white"
        />
      </svg>
    </Link>
  );
};
